import React from 'react';
import { FiAlertCircle, FiSave } from 'react-icons/fi';

/**
 * Barra pegada abajo que solo aparece si hay algo que guardar. Sustituye al
 * botón suelto y al aviso tardío de "no has cambiado nada".
 */
const BarraGuardado = ({ visible, totalCambios, guardando, onDescartar }) => {
  if (!visible) return null;

  return (
    <div className="perfil-barra-guardado" role="status">
      <span className="perfil-barra-guardado-info">
        <FiAlertCircle />
        {totalCambios === 1 ? '1 cambio sin guardar' : `${totalCambios} cambios sin guardar`}
      </span>

      <div className="perfil-barra-guardado-acciones">
        <button
          type="button"
          className="perfil-btn-secundario"
          onClick={onDescartar}
          disabled={guardando}
        >
          Descartar
        </button>
        {/* El submit lo gestiona el form que la envuelve */}
        <button
          type="submit"
          className="perfil-btn-primary"
          disabled={guardando}
        >
          <FiSave /> {guardando ? 'Guardando…' : 'Guardar cambios'}
        </button>
      </div>
    </div>
  );
};

export default BarraGuardado;
